export class IPermissaoModel {
  consultar: boolean;
  incluir: boolean;
  editar: boolean;
  excluir: boolean;
  visualizar: boolean;
  inativarReativar: boolean;
  imprimir: boolean;
  enviarParaAprovacao: boolean;
  planejar: boolean;
  elaborar: boolean;
  gerarNovaVersao: boolean;
  relatoria: boolean;
  avaliar: boolean;
  exportar: boolean;
  detalhar: boolean;
  gerarPAA: boolean;
  importar: boolean;
  executar: boolean;
  responsaveis: boolean;
  versoes: boolean;
  novo: boolean;
  inativar: boolean;
  arquivar: boolean;
  registrarPausa: boolean;
  preencher: boolean;
  cancelar: boolean;
  finalizar: boolean;
  historico: boolean;
  prescricaoFatoCadastrar: boolean;
  prescricaoFatoEnviarAnalise: boolean;
  prescricaoFatoVisualizar: boolean;
  prescricaoParCadastrar: boolean;
  prescricaoParEnviarCpar: boolean;
  prescricaoParVisualizar: boolean;
  incluirDestaques: boolean;
  incluirTipoDeTrabalho: boolean;
  incluirDispensas: boolean;
  monitorar: boolean;
  comparativoAlteracoes: boolean;
  publicar: boolean;
  sincronizar: boolean;
  habilitar: boolean;
  arquivosVisualizar: boolean;
  arquivosCadastrar: boolean;
  arquivosExcluir: boolean;
  arquivosEnviarAnalise: boolean;
  arquivosVincularDocumento: boolean;

  fichamentoCadastrar: boolean;
  fichamentoVisualizar: boolean;
  fichamentoExcluir: boolean;
  fichamentoIncluirEmpresasEnvolvidas: boolean;
  finalizarMonitoramento: boolean;
  gerarPDF: boolean;

  duplicar: boolean;
  cadastrarTabela: boolean;
  adicionarFaixa: boolean;
  distribuirProcesso: boolean;
  informacoesGerais: boolean;

  analiseInicialVisualizar: boolean;
  analiseInicialCadastrar: boolean;
  analiseInicialIncluirEnquadramento: boolean;
  verNaoPublicados: boolean;

  avocarProcesso: boolean;
  aprovar: boolean;
  visualizarPreview: boolean;
  anotacao: boolean;
  submeter: boolean;
  devolver: boolean;
  criar: boolean;


  arquivosAssociar?: boolean;
  processoExcluir?: boolean;
  processoAdicionarDocumento?: boolean;
  processoJuntar?: boolean;
  processoEspelhamento?: boolean;

}
